let backendHost;
let backendHostWithoutDomain;
let frontEndHost;
let serverHost;

const hostname = window && window.location && window.location.hostname;
if(hostname.indexOf('localhost') >= 0) {
    backendHost = "http://xxxxx.localhost:8080";
    backendHostWithoutDomain = "http://localhost:8080";
    frontEndHost = "http://localhost:3000";
    serverHost = "localhost:3000";
} else if(hostname.indexOf('esignandpay.com') >= 0) {
    backendHost = "https://xxxxx.esignandpay.com/esign_backend";
    backendHostWithoutDomain = "https://esignandpay.com/esign_backend";
    frontEndHost = "https://esignandpay.com";
    serverHost = "esignandpay.com";
}else if(hostname.indexOf('esignandpay.net') >= 0) {
    backendHost = "https://xxxxx.esignandpay.net/esign_backend";
    backendHostWithoutDomain = "https://esignandpay.net/esign_backend";
    frontEndHost = "https://esignandpay.net";
    serverHost = "esignandpay.net";
}
export const API_ROOT = `${backendHost}/api`;
export const BACKEND_SERVER = `${backendHost}`;
export const BACKEND_SERVER_WIHTOUT_DOMAIN = backendHostWithoutDomain
export const FRONT_END_HOST = frontEndHost;
export const SERVER_HOST = serverHost;


// WEBPACK FOOTER //
// ./src/api-config.js